module.exports = __webpack_public_path__ + "media/images/brand/cross-red-c75447b0e613bc8bd7ec534571af41c8.svg";